import React from "react";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Moment from 'moment';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { CgCloseR } from "react-icons/cg";

const HolidayRequestDetailsNode = ({ rights, t, isDisabled, data, events, css }) => {
    const [key, setKey] = useState('home');

    useEffect(() => {
    }, [data]);

    return (
        <>
         <label className='labelhotel'>{t('requester')}</label>
         <label className='blacklabel'>{/*data.record.Hotel_ID+" "+*/data.record.voornaam +", "+data.record.achternaam}</label>

            <label className='labelhotel'>{t('Startdatum')}</label>
            <input type="date" id="startdatum" name="startdatum" value={Moment(data.record.startdatum).format('yyyy-MM-DD')} className='date2' disabled={isDisabled} />
            <label className='labelhotel'>{t('Einddatum')}</label>
            <input type="date" id="startdatum" name="startdatum" value={Moment(data.record.einddatum).format('yyyy-MM-DD')} className='date2' disabled={isDisabled} />
            <label className='labelhotel'>{t('Redenaanvraag')}</label>
            <textarea id="Reason" name="reden" className="textareaReason2" value={data.record.reden !== null ? data.record.reden : ""} disabled={isDisabled}></textarea>


        </>
    );
}


export default HolidayRequestDetailsNode;
